import React from 'react';
import { withTranslation } from 'react-i18next';
import ListManual from './ListManual';
import './manuals.css';

function Api({ t }) {
    const manuals = [
        {
            "url": "https://owncloud.signaturit.com/s/RTpXeJgXz6AbpxG",
            "title": t('manuals.api.vidSignerApi'),
            "description": t('manuals.api.vidSignerApiInfo')
        },
        {
            "url": "https://owncloud.signaturit.com/s/HJhWlwytEbKeGrW",
            "title": t('manuals.api.vidCloudMngRestServices'),
            "description": t('manuals.api.vidCloudMngRestServicesInfo')
        }
    ];

    return <ListManual links={manuals} />;
}

export default withTranslation()(Api);